export const PRODUCTS_LIST_REQUEST = 'PRODUCTS_LIST_REQUEST'
export const PRODUCTS_LIST_SUCCESS = 'PRODUCTS_LIST_SUCCESS'
export const PRODUCTS_LIST_FAIL = 'PRODUCTS_LIST_FAIL'


export const PRODUCTS_DETAILS_REQUEST = 'PRODUCTS_DETAILS_REQUEST'
export const PRODUCTS_DETAILS_SUCCESS = 'PRODUCTS_DETAILS_SUCCESS'
export const PRODUCTS_DETAILS_FAIL = 'PRODUCTS_DETAILS_FAIL'

export const PRODUCTS_DELETE_REQUEST = 'PRODUCTS_DELETE_REQUEST'
export const PRODUCTS_DELETE_SUCCESS = 'PRODUCTS_DELETE_SUCCESS'
export const PRODUCTS_DELETE_FAIL = 'PRODUCTS_DELETE_FAIL'

export const PRODUCTS_CREATE_REQUEST = 'PRODUCTS_CREATE_REQUEST'
export const PRODUCTS_CREATE_SUCCESS = 'PRODUCTS_CREATE_SUCCESS'
export const PRODUCTS_CREATE_FAIL = 'PRODUCTS_CREATE_FAIL'
export const PRODUCTS_CREATE_RESET = 'PRODUCTS_CREATE_RESET'

export const PRODUCTS_UPDATE_REQUEST = 'PRODUCTS_UPDATE_REQUEST'
export const PRODUCTS_UPDATE_SUCCESS = 'PRODUCTS_UPDATE_SUCCESS'
export const PRODUCTS_UPDATE_FAIL = 'PRODUCTS_UPDATE_FAIL'
export const PRODUCTS_UPDATE_RESET = 'PRODUCTS_UPDATE_RESET'


export const PRODUCTS_CREATE_REVIEW_REQUEST = 'PRODUCTS_CREATE_REVIEW_REQUEST'
export const PRODUCTS_CREATE_REVIEW_SUCCESS = 'PRODUCTS_CREATE_REVIEW_SUCCESS'
export const PRODUCTS_CREATE_REVIEW_FAIL = 'PRODUCTS_CREATE_REVIEW_FAIL'
export const PRODUCTS_CREATE_REVIEW_RESET = 'PRODUCTS_CREATE_REVIEW_RESET'

export const PRODUCTS_TOP_REQUEST = 'PRODUCTS_TOP_REQUEST'
export const PRODUCTS_TOP_SUCCESS = 'PRODUCTS_TOP_SUCCESS'
export const PRODUCTS_TOP_FAIL = 'PRODUCTS_TOP_FAIL'